import {graphql} from 'react-relay'

export const buildProblemsPreviewQuery = graphql`
  query BuildProblemsPreviewQuery($locator: String!) {
    builds(locator: $locator) {
      ...BuildProblemsPreviewDependencyIdsFragment
    }
  }
`

export const getBuildProblemsPreviewVariables = (buildLocator: string) => ({
  locator: `defaultFilter:false,snapshotDependency(to:(${buildLocator})),count:-1`,
})
